import { createApi } from '@reduxjs/toolkit/query/react';
import createBaseQuery from '../../utils/baseQuery';

// Create a base query with the Bible Seminars endpoint prefix.
const baseQueryBibleSeminars = createBaseQuery('events');

export const bibleSeminarsApiSlice = createApi({
    reducerPath: 'bibleSeminarsApi',
    baseQuery: baseQueryBibleSeminars,
    tagTypes: ['BibleSeminars', 'BibleSeminarMembers'],
    endpoints: (builder) => ({
        createBibleSeminar: builder.mutation({
            query: (seminarData) => ({
                url: '/create-bible-seminar',
                method: 'POST',
                body: seminarData,
            }),
            invalidatesTags: ['BibleSeminars'],
        }),

        updateBibleSeminar: builder.mutation({
            query: (seminarData) => ({
                url: '/update-bible-seminar',
                method: 'PUT',
                body: seminarData,
            }),
            invalidatesTags: ['BibleSeminars'],
        }),

        deleteBibleSeminar: builder.mutation({
            query: (seminarId) => ({
                url: `/delete-bible-seminar`,
                method: 'DELETE',
                body: { id: seminarId }
            }),
            invalidatesTags: ['BibleSeminars'],
        }),

        getBibleSeminars: builder.query({
            query: (params) => ({
                url: '/get-bible-seminars',
                method: 'POST',
                body: params,
            }),
            providesTags: ['BibleSeminars'],
        }),

        registerBibleSeminarMember: builder.mutation({
            query: (memberData) => ({
                url: '/register-member',
                method: 'POST',
                body: memberData,
            }),
        }),

        getBibleSeminarMembers: builder.query({
            query: ({ event_id, page, limit }) => ({
                url: '/get-seminar-members',
                method: 'POST',
                body: { event_id, page, limit },
            }),
            providesTags: ['BibleSeminarMembers'],
            keepUnusedDataFor: 0,
        }),

        getActiveBibleSeminarId: builder.query({
            query: () => ({
                url: '/active-bible-seminar',
                method: 'GET',
            }),
            providesTags: ['BibleSeminars'],
        }),

        checkActiveConflict: builder.mutation({
            query: (conflictData) => ({
                url: '/check-active-conflict',
                method: 'POST',
                body: conflictData,
            }),
        }),
    }),
});

export const {
    useCreateBibleSeminarMutation,
    useUpdateBibleSeminarMutation,
    useDeleteBibleSeminarMutation,
    useGetBibleSeminarsQuery,
    useRegisterBibleSeminarMemberMutation,
    useLazyGetBibleSeminarMembersQuery,
    useGetActiveBibleSeminarIdQuery,
    useCheckActiveConflictMutation,
} = bibleSeminarsApiSlice;
